import { LogoCollection } from "../components/logo-collection";
import { TestimonialCarousel } from "../components/testimonial-carousel/TestimonialCarousel";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean =>
  __typename === "VinoData_StaticBlock" &&
  staticType === "Whiskymofo Social Proof";

const create = (data: any): JSX.Element => {
  return (
    <>
      <LogoCollection
        heading="Iconic whiskies and spirits from the world's best distilleries for less than anywhere else guaranteed."
        subheading={"75,000+ BOTTLES SOLD & COUNTING"}
        tagline={"SEE WHAT YOU'VE BEEN MISSING..."}
        logoImageUrl="https://res.cloudinary.com/vinomofo/image/upload/v1754880970/Whisky%202.0/Whiskymofo%20Landing/Group_40592.png"
      />
      <TestimonialCarousel />
    </>
  );
};

export default { test, create };
